var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignApplication(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17703",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13097",
    d: "M5.95 13h6.9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13098",
    d: "M6 16h3.89"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13099",
    d: "M9.893 21H4.97A1.985 1.985 0 013 19V5a1.985 1.985 0 011.97-2h10.06A1.985 1.985 0 0117 5v6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13100",
    d: "M19.293 12.707L13 19v2h2l6.293-6.293a1 1 0 000-1.414l-.586-.586a1 1 0 00-1.414 0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13108",
    d: "M7.316 9.093s1.316-.632 1.316-1.579V6.408l-.96-.345a1.049 1.049 0 00-.713 0L6 6.408v1.106c0 .948 1.316 1.579 1.316 1.579z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13102",
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}
export default SvgSignApplication;


//////////////////
// WEBPACK FOOTER
// ./src/components/Quoters/AmericoLoanProtection/icons/signApplication.svg
// module id = 8222
// module chunks = 13